import { Injectable, inject } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CheckoutsState } from './checkouts.state';
import { Checkout } from './models/checkout';
import { GetCheckouts, PostCheckout, PostRenewCheckout, PostReturnCheckout, SetCheckout } from './checkouts.actions';
import { FromScreen } from 'src/app/models/from-screen';

@Injectable({
  providedIn: 'root',
})
export class CheckoutsFacade {
  private readonly store = inject(Store);

  @Select(CheckoutsState.getCheckouts) checkouts$!: Observable<Checkout[]>;
  @Select(CheckoutsState.getIsLoading) isLoading$!: Observable<boolean>;

  get checkouts() {
    return this.store.selectSnapshot(CheckoutsState.getCheckouts);
  }

  getCheckouts(): Observable<GetCheckouts> {
    return this.store.dispatch(new GetCheckouts());
  }

  postCheckout(recordId: string, from: FromScreen, issueDate?: string, rhId?: string): Observable<PostCheckout> {
    return this.store.dispatch(new PostCheckout(recordId, from, issueDate, rhId));
  }

  postRenewCheckout(checkout: Checkout): Observable<PostRenewCheckout> {
    return this.store.dispatch(new PostRenewCheckout(checkout));
  }

  postReturnCheckout(checkoutId: string): Observable<PostReturnCheckout> {
    return this.store.dispatch(new PostReturnCheckout(checkoutId));
  }

  setCheckout(checkout: Checkout): Observable<SetCheckout> {
    return this.store.dispatch(new SetCheckout(checkout));
  }

  getCheckoutByRecordId(recordId: string, issueDate?: string, rhId?: string): Checkout {
    if (issueDate) {
      return this.checkouts.filter((c) => c.recordId === recordId).find((c) => c.issueDate === issueDate);
    }

    if (rhId) {
      return this.checkouts.filter((c) => c.recordId === recordId).find((c) => c.rssRhId === rhId);
    }

    return this.checkouts.find((checkout) => checkout.recordId === recordId);
  }

}
